export const TaxIntakeStatusList = ["New", "Drafting", "Signed Intake", "Ready to File", "In progress", "Waiting on Data", "Completed", "Out of Service Area"];


export function getTaxYear() {
  const aDate = new Date();
  const cutOffDate = new Date(aDate.getUTCFullYear(), 12, 13, 0, 0, 0, 0);
  let curTaxYear = new Date().getUTCFullYear() - (aDate < cutOffDate ? 1 : 0);
  // console.log("cutOffData", cutOffDate);
  // const bDate = new Date(cutOffDate);
  // bDate.setUTCFullYear(curTaxYear);
  return curTaxYear;
}


// WEBPACK FOOTER //
// ./src/constants/TaxIntakeConstants.js